"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"

export function ProviderInterestForm() {
  const [state, setState] = useState<"idle" | "sending" | "done" | "error">("idle")

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    const f = new FormData(e.currentTarget)
    // Honeypot: real users leave this empty.
    if (f.get("website")) { setState("done"); return }
    setState("sending")
    try {
      const res = await fetch("/api/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          formType: "provider-interest",
          name: f.get("name"), email: f.get("email"), company: f.get("company"),
          inquiryType: f.get("kind"), message: f.get("message"),
        }),
      })
      if (!res.ok) throw new Error()
      setState("done")
    } catch { setState("error") }
  }

  if (state === "done") return <p role="status" className="rounded-md border border-border bg-card p-4">Thanks — we&apos;ll be in touch.</p>

  const field = "w-full rounded-md border border-border bg-background p-3"
  return (
    <form onSubmit={onSubmit} className="grid gap-3">
      <label className="grid gap-1 text-sm">Name<input name="name" required className={field} autoComplete="name" /></label>
      <label className="grid gap-1 text-sm">Work email<input name="email" type="email" required className={field} autoComplete="email" /></label>
      <label className="grid gap-1 text-sm">Organization<input name="company" className={field} autoComplete="organization" /></label>
      <label className="grid gap-1 text-sm">What do you do?
        <select name="kind" className={field} defaultValue="msp">
          <option value="msp">MSP / MSSP</option><option value="ir">Incident-response firm</option>
          <option value="consultant">Security / compliance consultant</option><option value="counsel">Law firm</option>
          <option value="insurer">Insurer / broker</option><option value="other">Other</option>
        </select>
      </label>
      <label className="grid gap-1 text-sm">How would you use it?<textarea name="message" rows={4} className={field} /></label>
      <input name="website" tabIndex={-1} autoComplete="off" aria-hidden className="hidden" />
      <Button type="submit" size="lg" disabled={state === "sending"} className="bg-accent-solid text-accent-solid-foreground hover:bg-accent-solid/90">
        {state === "sending" ? "Sending…" : "Get in touch"}
      </Button>
      {state === "error" && <p role="alert" className="text-sm text-destructive">Something went wrong. Please email us instead.</p>}
      <p className="text-xs text-muted-foreground">This is the only place on the site that asks for contact details, and it is entirely optional. The incident guide never asks for them.</p>
    </form>
  )
}
